var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-no-wrap"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.hourNumber)+" ")]),_c('span',{staticClass:"grey--text text-caption pl-1"},[_vm._v(" ["+_vm._s(_vm._f("trimZeroesLeft")(_vm.item.startsAt))+" - "+_vm._s(_vm._f("trimZeroesLeft")(_vm.item.endsAt))+"] ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }